exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".row-component>div[data-v-06874f6c]{float:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-06874f6c&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/grid/GridComponentFactory.vue
// module id = 837
// module chunks = 2